var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-builder-video",class:[_vm.excludeFromPrintClassName]},[(_vm.isYoutubeVideo)?_c('youtube',{ref:"youtube",staticClass:"youtube",attrs:{"video-id":_vm.youtubeId}}):_c('video',{attrs:{"src":_vm.link,"controls":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }